import React, { Component } from 'react';
import  { connect } from 'react-redux';
import { types } from '../../config/types';
import { addTypeId } from '../../redux/actions/typeId';
import { INPUT_TYPES } from '../../config/constants';


class InputTypesList extends Component {

    addTypeToForm = ({ unique, name, type }) => {
        const { typeIds, activeBuilderType } = this.props;

        const typeToAdd = typeIds[activeBuilderType].find(el => el.type === type);

        if (type === INPUT_TYPES.SELECT_USER_GROUP) {
            if (!('UPDATE_FORM_CONFIG' in window) ||
                (('UPDATE_FORM_CONFIG' in window) && !window.UPDATE_FORM_CONFIG.eventId)
            ) {
                alert('No Duuzra is linked. Please link Duuzra first');
                return;
            }
        }

        if (unique && typeToAdd) {
            alert('Type ' + typeToAdd.name + ' is unique and already added');
        } else {
            this.props.addTypeId({
                activeBuilderType,
                typeId: {
                    id: Date.now(),
                    name,
                    type
                }
            });
        }
    };

    render() {
        const { activeBuilderType } = this.props;
        return (
            <ul>
                {types.map(item => {
                    const isVisible = item[activeBuilderType]
                    return (
                        <li
                            style={{ display: isVisible ? 'block' : 'none' }}
                            key={item.id}
                            data-id={item.id}
                            onClick={() => {this.addTypeToForm(item)}}
                            className="input-item-name"
                        >{ item.name }</li>
                    )
                })}
            </ul>
        );
    }
}


export default connect(
    state => ({
        typeIds: state.typeId,
        activeBuilderType: state.activeBuilderType,
    }),
    { addTypeId }
  )(InputTypesList);



